export default __webpack_public_path__ + "static/backgroundHero-f38901b5d92417b0ddc56516e68e13cd.jpg";